import tacHelpers from './tacHelpers';
import { TacHistoryObject, TacModel } from './tacTypes';
import { State } from '../StateTypes';
import { Wall } from '../../generalTypes';
import { selectUseMetric } from '../dexfSettings/dexfSettingsSelectors';
import { mm } from '../../util/measures';

/**
 * Selects current tac
 *
 * @param state
 * @returns TacModel | null
 */
export const selectTac = ({ tac: { present } }: State): TacModel | null =>
  present;

/**
 * Select past tac
 *
 * @param past
 * @returns TacHistoryObject
 */
export const selectPastTac = ({ tac: { past } }: State): TacHistoryObject =>
  past;

/**
 * Select future tac
 * @param future
 * @returns TacHistoryObject
 */
export const selectFutureTac = ({ tac: { future } }: State): TacHistoryObject =>
  future;

/**
 * Returns true if tac scene is empty
 *
 * @param state
 * @returns {boolean}
 */
export const selectTacIsEmpty = (state: State): boolean =>
  !selectTac(state)?.items.some(item => tacHelpers.hasRealArticle(item));

/**
 * Select "disableMountingRails" setting
 *
 * @param state
 * @returns {boolean}
 */
export const selectDisableMountingRails = (state: State): boolean =>
  selectTac(state)?.settings?.disableMountingRails;

/**
 * Select has undo history
 *
 * @param state
 * @returns {*}
 */
export const selectHasUndoHistory = (state: State): boolean =>
  !!selectPastTac(state).length;

/**
 * Select has redo history
 *
 * @param state
 * @returns {*}
 */
export const selectHasRedoHistory = (state: State): boolean =>
  !!selectFutureTac(state).length;

export const selectPresentWall = (state: State): Wall | undefined =>
  selectTac(state)?.wall;

export const selectWallPoints = (state: State): any =>
  selectPresentWall(state)?.points;

export const selectWallSize = (state: State): any =>
  selectPresentWall(state)?.size;

export const selectCeilingHeightBasedOnMarket = (
  state: State,
  height: number
) => (selectUseMetric(state) ? mm.toCm(height) : mm.toInches(height));
